// Message handlers the Nile iOS app's WKWebView registers; absent in a browser.
interface WebKitMessageHandlers {
  /** Fetches the URL natively, without the page's auth headers, then saves it. */
  startDownload?: {
    postMessage: (message: { url: string; filename: string }) => void;
  };
  /** Saves bytes the page already fetched; absent in Nile iOS 1.28 and older. */
  saveDownload?: {
    postMessage: (message: { data: string; filename: string }) => void;
  };
  /** Sets the user on the app's own Sentry; absent in Nile iOS 1.29 and older. */
  setUser?: {
    postMessage: (message: { id: string; email: string } | null) => void;
  };
}

declare global {
  interface Window {
    webkit?: {
      messageHandlers?: WebKitMessageHandlers;
    };
  }
}

/** The build the iOS app appends to its user agent as `Nile/<build>`; null outside the app or before 1.30. */
export const getNileAppBuild = (userAgent = navigator.userAgent) => userAgent.match(/\bNile\/(\S+)/)?.[1] ?? null;

export const setNativeSentryUser = (user: { id: string; email: string } | null) => {
  window.webkit?.messageHandlers?.setUser?.postMessage(user);
};
